import styled from "styled-components";

export default styled.span`
  color: red;
  margin-left: 50px;
`;
